export default {
      id: "chevron-usage",
      viewBox: "0 0 11.88 6.68",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#chevron-usage",
      toString: function () {
        return this.url;
      }
    }